export type UrgencyTier = "normal" | "warning" | "critical";

/**
 * Maps remaining time to a coarse urgency tier by thirds of the originally
 * granted duration: first third normal, middle third warning, last third
 * (and any overrun) critical. A non-positive duration yields normal.
 */
export function urgencyTier(remainingMs: number, durationMs: number): UrgencyTier {
  if (durationMs <= 0) {
    return "normal";
  }
  const fraction = remainingMs / durationMs;
  if (fraction > 2 / 3) {
    return "normal";
  }
  if (fraction > 1 / 3) {
    return "warning";
  }
  return "critical";
}
